import { render, staticRenderFns } from "./CursoPage.vue?vue&type=template&id=5a6311b1"
import script from "./CursoPage.js?vue&type=script&lang=js&external"
export * from "./CursoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports